import React from 'react'
import { Link } from 'gatsby'

import logo from '../img/logo.svg'
import facebook from '../img/social/facebook.svg'
import instagram from '../img/social/instagram.svg'
import twitter from '../img/social/twitter.svg'
import vimeo from '../img/social/vimeo.svg'

const Footer = class extends React.Component {
  render() {
    return (
        <footer className="footer has-background-black has-text-white-ter">
          <div className="content has-text-centered">
            <h3 style={{
              color: 'white',
              lineHeight: '1',
              padding: '0.25em',
            }} >Uvdal kraftforsyning</h3>
          </div>
          <div className="content has-text-centered has-background-black has-text-white-ter">
            <div className="container has-background-black has-text-white-ter">
              <div style={{ maxWidth: '100vw' }} className="columns">
                <div className="column is-4">
                  <section className="menu">
                  </section>
                </div>
                <div className="column is-4">
                  <section>
                    <ul className="menu-list">

                    </ul>
                  </section>
                </div>
                <div className="column is-4 social">

                </div>
              </div>
            </div>
          </div>
        </footer>
    )
  }
}

export default Footer
